import { FunctionComponent } from 'react'

import { Flex } from '@theme-ui/components'

import styled from 'styled-components'

import {
  baseColors,
  makeTransition,
  Text,
  TickCircleFilled,
} from '@fairhq/common'
import { useAreaProgress } from 'features/assessmentQuestions/hooks/useAreaProgress'
import { TickThin } from 'features/reportsEqualityAreas/TickThin'
import { useCharlieUser } from 'hooks/useCharlieUser'
import { AreaSource } from 'store/area/types'

import RouterLink from 'ui-kit/RouterLink'
import { insightsSelfAssessmentStartedEvent } from 'utils/analytics/amplitudeEvents'

const StyledRouterLink = styled(RouterLink)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`

export const LocalArea: FunctionComponent<{
  label: string
  code: string
}> = ({ label, code }) => {
  const { completed, total } = useAreaProgress({
    area: { code },
    group: AreaSource.COMPANY,
  })

  const getLabel = () => (
    <Text element="span" size="sm" fontWeight={600} type="body">
      {label}
    </Text>
  )

  const charlieUser = useCharlieUser()

  return (
    <Flex
      sx={{
        bg: 'white',
        border: `1px solid ${baseColors.borderBackground}`,
        borderRadius: 4,
        px: '32px',
        py: '20px',
        gap: '40px',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: baseColors.contentContent,
        transition: makeTransition('color'),
        position: 'relative',
        lineHeight: '24px',
      }}
      onClick={() =>
        insightsSelfAssessmentStartedEvent({ topic: code }, charlieUser)
      }
    >
      {total === 0 ? (
        getLabel()
      ) : (
        <StyledRouterLink to={`/assessment/${code}/questions`}>
          {getLabel()}
        </StyledRouterLink>
      )}
      <Flex sx={{ alignItems: 'center', gap: '8px', svg: { flexShrink: 0 } }}>
        <Text
          element="span"
          size="sm"
          fontWeight={700}
          type="body"
          color={baseColors.contentMuted}
        >
          {completed}/{total}
        </Text>
        {completed >= total ? (
          <TickCircleFilled outline={baseColors.boldActionSuccess} />
        ) : (
          <TickThin width="20" height="20" fill="transparent" />
        )}
      </Flex>
    </Flex>
  )
}
